import type { DictationCue } from './applyDictation.ts';

const NON_WORD = /[\p{P}\p{S}\s]/gu;

/** Next character to reveal for Alt+H (extension dictationHint). */
export function nextDictationHintChar(cue: DictationCue): string | null {
  const raw = cue.dictationRaw;
  if (!raw) return null;
  const typed = cue.dictationTyped ?? '';
  const remaining =
    typed && raw.startsWith(typed) ? raw.slice(typed.length) : raw.replace(typed, '');
  const ch = remaining[0];
  return ch || null;
}

/**
 * Seek target (ms) for Alt+W — first seg whose punctuation-stripped text is not yet
 * fully covered by typed progress (extension dictationPlayWord).
 */
export function dictationPlayWordSeekMs(cue: DictationCue): number | null {
  const segs = cue.segs;
  if (!segs?.length) return null;
  const typedOnly = (cue.dictationTyped ?? '').replace(NON_WORD, '');
  let acc = '';
  for (const seg of segs) {
    acc += (seg.text ?? '').replace(NON_WORD, '');
    if (!typedOnly.startsWith(acc)) {
      return seg.start + 1;
    }
  }
  return null;
}
